import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { DrawerService } from '../../../../../core/services/drawer.service';
import { DRAWER_IDS } from '../../../../../core/constants/drawer-ids.constant';
import { ManageStudentDrawerParams } from '../../../insights.interface';
import { Subject, takeUntil } from 'rxjs';
import { SvgIconComponent } from 'angular-svg-icon';
import { CommonModule } from '@angular/common';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { BehaviorCategoryDataComponent } from './behavior-category-data/behavior-category-data.component';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NoDataComponent } from '../../../../../pages/content/no-data/no-data.component';

@Component({
  selector: 'app-add-data',
  standalone: true,
  imports: [
    SvgIconComponent,
    CommonModule,
    NzTabsModule,
    BehaviorCategoryDataComponent,
    NzFormModule,
    NzButtonModule,
    NoDataComponent,
  ],
  templateUrl: './add-data.component.html',
  styleUrl: './add-data.component.scss',
})
export class AddDataComponent {
  private destroy$ = new Subject<void>();
  selectedTabIndex = 0;
  caseParams: ManageStudentDrawerParams = {} as ManageStudentDrawerParams;
  @ViewChild(BehaviorCategoryDataComponent)
  behaviorCategoryComponent!: BehaviorCategoryDataComponent;
  disableState = false;
  constructor(
    private drawerService: DrawerService,
    private cdr: ChangeDetectorRef
  ) {
    this.setupDrawerSubscription();
  }

  private setupDrawerSubscription(): void {
    this.drawerService
      .getParams<ManageStudentDrawerParams>(DRAWER_IDS.ADD_DATA)
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        if (params) {
          this.caseParams = params;
        }
      });
  }

  selectTab(index: number): void {
    this.selectedTabIndex = index;
    this.cdr.detectChanges();
  }
  onNext() {
    this.behaviorCategoryComponent.goToNext();
  }

  onBack() {
    this.behaviorCategoryComponent.onBack();
  }

  handleDisable(state: boolean) {
    this.disableState = state;
  }
}
